import React, { useState } from "react";
import { Search } from "@hedgefund/shared";
import debounce from "lodash/debounce";
import { useHistory } from "react-router";
import { aumData } from "../../../SearchAllocators";

const SearchAllocator = () => {
  const [aumFilter, setAumFilter] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const history = useHistory();

  const handleSearch = debounce((text) => {
    setSearchValue(text);
  }, 1000);

  const onSubmitSearchHandler = (e) => {
    e.preventDefault();
    setSearchValue(searchValue);

    history.push(
      `/search-allocators?keyword=${searchValue}&dropDownAumValue=${aumFilter}`
    );
  };
  return (
    <Search
      headTitle={"Search Allocator"}
      showDropDown={false}
      aumData={aumData}
      handleSearch={handleSearch}
      onSubmit={onSubmitSearchHandler}
      onChangeAum={(e) => setAumFilter(e)}
      title="Search Allocators"
    />
  );
};

export default SearchAllocator;
